import type { TranslatableString } from '~/types/widgets/widgetTypes'
import getWidgetTextTranslation from '~/utils/getWidgetTextTranslation'

export default function (image: TranslatableString): string {
  try {
    const translation = getWidgetTextTranslation(image)

    const valueObject = JSON.parse(translation)

    return valueObject.fileUrl ?? ''
  } catch {
    return '/banners/dealzone-service-hero.png'
  }
}
